import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { Calendar, Clock, CheckCircle } from 'lucide-react'
import api from '../../services/api'

/**
 * Mobile Tasks Page
 * Shows tasks for today and upcoming tasks
 */
function MobileTasksPage() {
  const { t } = useTranslation()

  const { data: tasks, isLoading } = useQuery({
    queryKey: ['mobile-tasks'],
    queryFn: async () => {
      const response = await api.get('mobile/tasks')
      return response.data
    }
  })

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-full bg-canvas dark:bg-gray-900">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent"></div>
      </div>
    )
  }

  return (
    <div className="p-4 space-y-4 min-h-full bg-canvas dark:bg-gray-900">
      <h1 className="text-2xl font-bold text-ink dark:text-white">
        {t('mobile.tasks.title', { defaultValue: 'Mijn Taken' })}
      </h1>

      {tasks && tasks.length > 0 ? (
        <div className="space-y-3">
          {tasks.map((task) => (
            <div
              key={task.id}
              className="r11-card p-4"
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <h3 className="font-medium text-ink dark:text-white">
                    {task.title}
                  </h3>
                  <p className="text-sm text-muted dark:text-gray-400 mt-1">
                    {task.project_name}
                  </p>
                  {task.due_date && (
                    <div className="flex items-center gap-2 mt-2">
                      <Clock className="w-4 h-4 text-faint" />
                      <span className="text-sm text-muted dark:text-gray-400">
                        {new Date(task.due_date).toLocaleDateString('nl-NL')}
                      </span>
                    </div>
                  )}
                </div>
                {task.status === 'completed' && (
                  <CheckCircle className="w-5 h-5 text-green-500" />
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="r11-card r11-card-pad">
          <div className="r11-empty">
            <Calendar className="r11-empty__icon" />
            <p className="r11-empty__title">
              {t('mobile.tasks.no_tasks', { defaultValue: 'Geen taken' })}
            </p>
          </div>
        </div>
      )}
    </div>
  )
}

export default MobileTasksPage
